/* Return result of pagination view with summary */
function createPaginationItem(page, label, isDisabled, isCurrent) {
	let itemClass = isDisabled ? 'page-item disabled' : 'page-item';
	itemClass += isCurrent ? ' active' : '';
	let clickAction = isDisabled ? '' : ` onClick="actionFilterRecord(${page})"`;

	return `
        <li class="${itemClass}">
            <a class="page-link" href="javascript:void(0)" aria-label="${label}"${clickAction}>
                <span aria-hidden="true">${label}</span>
                <span class="sr-only">${label}</span>
            </a>
        </li>
    `;
}

function createEllipsisForHiddenItems(item, totalPages, quantityOfItemsOnTheLeft, quantityOfItemsOnTheRight) {
	const isSecondItemAndHasItemOnTheLeft = item === 2 && quantityOfItemsOnTheLeft;
	const isLastItemAndHasItemsOnTheRight = item === totalPages && quantityOfItemsOnTheRight;

	if (isSecondItemAndHasItemOnTheLeft || isLastItemAndHasItemsOnTheRight) {
		return createPaginationItem(item, '...', true);
	}

	return '';
}

function validateCanHiddenItem(item, currentPage, totalPages, quantityOfItemsOnTheLeft, quantityOfItemsOnTheRight) {
	const isFirstItem = item === 1;
	const isLastItem = item === totalPages;
	const isOnTheLeftAndOutOfRange = quantityOfItemsOnTheLeft && item < currentPage - quantityOfItemsOnTheLeft;
	const isOnTheRightAndOutOfRange = quantityOfItemsOnTheRight && item > currentPage + quantityOfItemsOnTheRight;

	return !isFirstItem && !isLastItem && (isOnTheLeftAndOutOfRange || isOnTheRightAndOutOfRange);
}

window.globalPagination = function( Totals, Current )
{
	Totals = parseInt( Totals );
	Current = parseInt( Current );
	var Limit = parseInt($("#pageLimit").val());
	var Html = '';
	var Prev = 0;
	var Next = 0;
	var Summary = '';

	$("html, body").animate({
		scrollTop: $('#app').offset().top
	}, 500);

	if( Totals <= 0 ){
		$(".displayPagination").html('').attr('data-current',1);
		$(".displayRecordSummary").html('');

	    return false;
	}

	if( Limit <= 0){
		Limit = 50;
	}
	var Pages = Math.ceil( Totals / Limit );
	if( Pages > 1 && Current > 1 ){
		Prev = Current - 1;
	}
	if( Pages > 1 && Current < Pages ){
		Next = Current + 1;
	}

	var Offset = ( Current - 1 ) * Limit;
	var Start = Offset + 1;
	var End = Math.min( (Offset + Limit), Totals );

	Summary = 'Showing '+Start+' to '+End+' of '+Totals+' entries';


	const minLengthForHiddenItems = 7;
	let quantityOfItemsOnTheLeft = 2;
	let quantityOfItemsOnTheRight = 2;
	let range = quantityOfItemsOnTheLeft + quantityOfItemsOnTheRight;

	if (Current <= range) {
		quantityOfItemsOnTheLeft = 0;
	}

	if (Current > (Pages - range)) {
		quantityOfItemsOnTheRight = 0;
	}

	Html += '<nav aria-label="Page navigation"><ul class="pagination justify-content-end">';

	Html += createPaginationItem(Prev, '&laquo;', Prev <= 0);

	for(let i = 1; i <= Pages; i++) {
		if (Pages > minLengthForHiddenItems) {
			Html += createEllipsisForHiddenItems(i, Pages, quantityOfItemsOnTheLeft, quantityOfItemsOnTheRight);

			if (validateCanHiddenItem(i, Current, Pages, quantityOfItemsOnTheLeft, quantityOfItemsOnTheRight)) {
				continue;
			}
		}

		Html += createPaginationItem(i, i, false, Current === i);
	}

	Html += createPaginationItem(Next, '&raquo;', Next <= 0);

	Html += '</ul></nav>';

	$(".displayPagination").html(Html).attr('data-current',Current);
	$(".displayRecordSummary").html(Summary);
};

/* Return result of sorting */
window.globalSorting = function()
{
	var Sort = $("#record_feature_table").attr('data-sort');
	var SortOrder = $("#record_feature_table").attr('data-sort-order');
	$("#record_feature_table th").each(function(){
		$(this).find('i').remove();
		if($(this).attr('data-sort') == Sort){
			if(SortOrder == 'desc')
				$(this).append('<i class="fas fa-long-arrow-alt-up"></i><i class="fas fa-long-arrow-alt-down text-gray"></i>');
			else
				$(this).append('<i class="fas fa-long-arrow-alt-up text-gray"></i><i class="fas fa-long-arrow-alt-down"></i>');
		} else if($(this).attr('data-sort') != null) {
			$(this).append('<i class="fas fa-long-arrow-alt-up text-gray"></i><i class="fas fa-long-arrow-alt-down text-gray"></i>');
		}
	});
	$("#record_feature_table").removeAttr('data-request-sort');
	$("#record_feature_table").removeAttr('data-request-sort-order');
};

/* Return page limit */
window.globalPageLimit = function()
{
	var Limit = [10,20,50,100,200];
	var Html = 'Show <select autocomplete="off" class="form-control w-auto d-inline-block" id="pageLimit">';
	$.each( Limit, function(i,v){
		let selectedAttribute = (v === 50) ? ' selected' : '';
		Html += '<option value="'+v+'"'+selectedAttribute+'>'+v+'</option>';
	});
	Html += '</select> entries';
	$(".displayPageLimit").html(Html);
};

/* action is called when filter is active like sorting, pagination, filteration */
window.actionFilterRecord = function( Page, PageChange = false )
{
	$('.record_table_overlay').removeClass('d-none');
	$('body').css('overflow','hidden');
	var Request = {};

	if( $(".filterRecordField").length > 0 ){
		$(".filterRecordField input").each(function(){
			if( $(this).attr('name') != null && $(this).attr('name') != '' && $(this).val() != '')
			{
				Request[$(this).attr('name')] = $(this).val();
			}
		});

		$(".filterRecordField select").each(function(){				
			if( $(this).attr('name') != null && $(this).attr('name') != '' && $(this).val() != '')
			{
				Request[$(this).attr('name')] = $(this).val();
			}
		});
	}		

	Request["SortByOrder"] = 'asc';

	if( $("#record_feature_table").attr('data-request-sort') != null && $("#record_feature_table").attr('data-request-sort') != '' ){
		Request["SortBy"] = $("#record_feature_table").attr('data-request-sort');

		if( $("#record_feature_table").attr('data-request-sort-order') != null && $("#record_feature_table").attr('data-request-sort-order') != '' ){
			Request["SortByOrder"] = $("#record_feature_table").attr('data-request-sort-order');
		}
	} else {
		Request["SortBy"] = $("#record_feature_table").attr('data-sort');
		Request["SortByOrder"] = $("#record_feature_table").attr('data-sort-order');
	}

	Request["Limit"] = $("#pageLimit").val();			

	if(PageChange)
	{
		Page = 1;
	}

	ajaxRequestFilter( Request, Page );

	$("html, body").animate({ scrollTop: $("#app").offset().top }, 500);
};

/* Request to ajax get result according the parameters, sorting and pagination */
window.ajaxRequestFilter = function( Request, Page=1 )
{
	$('#ajax_record_error_msg').html('');
	$('#ajax_record_error_msg').parent().addClass('d-none');
	
	var Route = $("#record_feature_table").attr('data-route')+'?page='+Page;
	$.ajax({
        url: Route,
        method: "GET",
        data: Request,
        dataType: "json",
	    success: function (response) {

        	if(response.status)
        	{
        		if( response.data.Rows != null && $.isArray(response.data.Rows) )
        		{
        			actionResponseDisplay( response.data );
        			$("#record_feature_table").attr('data-sort',response.data.SortBy);
					$("#record_feature_table").attr('data-sort-order',response.data.SortByOrder)
					globalSorting();
					globalPagination( response.data.Totals, response.data.Page );
					if (typeof window.formatLocalDates === 'function') {
						window.formatLocalDates();
					}
        		}
        		else
        		{
        			$('#ajax_record_error_msg').html('Something went wrong');
					$('#ajax_record_error_msg').parent().removeClass('d-none');
        		}            		
        	}
        	else
        	{
        		$('#ajax_record_error_msg').html(response.message);
				$('#ajax_record_error_msg').parent().removeClass('d-none');
        	}
        	$('.record_table_overlay').addClass('d-none');               	
        	$('body').css('overflow','auto');
        },
		error: function (jqXHR, textStatus, errorThrown) {
        	$('#ajax_record_error_msg').html('Something went wrong');
			$('#ajax_record_error_msg').parent().removeClass('d-none');
			$('.record_table_overlay').addClass('d-none');	
			$('body').css('overflow','auto');			
        }
    });
};

/* Click action on filter submit button */
$(document).on("click","#filter_action",function(){		
	// var Page = $(".displayPagination").attr('data-current');
	// console.log(Page);
	actionFilterRecord( 1 );
});	

/* Click action on sorting */
$(document).on("click","#record_feature_table th",function(){
	if( $(this).attr('data-sort') != null )
	{		
		var CurrentSort = $("#record_feature_table").attr('data-sort');
		var CurrentSortOrder = $("#record_feature_table").attr('data-sort-order');

		var RequestSort = $(this).attr('data-sort');
		var RequestSortOrder = 'asc';		
		if(CurrentSort == RequestSort){
			if(CurrentSortOrder == 'asc')
				RequestSortOrder = 'desc';			
		}

		$("#record_feature_table").attr('data-request-sort',RequestSort);
		$("#record_feature_table").attr('data-request-sort-order',RequestSortOrder);

		var Page = $(".displayPagination").attr('data-current');
		actionFilterRecord( Page );
	}
});	

/* Change action on page limit */
$(document).on("change", "#pageLimit", function(){
	var Page = $(".displayPagination").attr('data-current');
	actionFilterRecord( Page, true );
});

window.number_format = function(number, decimals, dec_point, thousands_sep) {
    number = number.toFixed(decimals);

    var nstr = number.toString();
    nstr += '';
    var x = nstr.split('.');
    var x1 = x[0];
    var x2 = x.length > 1 ? dec_point + x[1] : '';
    var rgx = /(\d+)(\d{3})/;

    while (rgx.test(x1))
        x1 = x1.replace(rgx, '$1' + thousands_sep + '$2');

    return x1 + x2;
};

window.addslashes = function (str){
	let newString = (str + '')
    .replace(/[\\"']/g, '\\$&')
    .replace(/\u0000/g, '\\0');
	return newString;
}

$(function() {
	if ($.fn.dataTable) {
		$.extend($.fn.dataTable.defaults, {
			language: {
			    paginate: {
			        next: '<i class="fa fa-angle-double-right"></i>',
			        previous: '<i class="fa fa-angle-double-left"></i>'
			    }
			}
		});
	}
});

new MutationObserver(function() {
	document.body.classList.toggle('modal-open', document.querySelector('.modal.show') !== null);
}).observe(document.body, { childList: true, subtree: true });
